module.exports = __webpack_public_path__ + "167aac7349883d3d207924159af4c8cd.svg";